import React, { useState, ChangeEvent } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "./CustomSearch.scss";
interface CustomSearchProps {
	placeholder?: string;
	value?: string;
	onSearchChange?: (value: string) => void;
}

const CustomSearch: React.FC<CustomSearchProps> = ({
	placeholder = "Search",
	value = "",
	onSearchChange,
}) => {
	const [searchValue, setSearchValue] = useState(value);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value);
		onSearchChange && onSearchChange(e.target.value);
	};

	return (
		<div style={{ display: "flex", alignItems: "center" }} className="">
			<IconField iconPosition="right">
				<InputIcon className="pi pi-search"> </InputIcon>
				<InputText
					value={searchValue}
					onChange={handleChange}
					className="border border-spacing-1 w-full h-9 customsearch"
					placeholder={placeholder}
					style={{ width: "218px" }}
				/>
			</IconField>
		</div>
	);
};

export default CustomSearch;
